import { useInitialValues } from "../hooks/useInitialValues";
import { SearchFilter } from "./SearchFilter";

export const Filters = ({ searchData }: { searchData: Function }) => {
	useInitialValues();
	return (
		<>
			<SearchFilter searchData={searchData} />
		</>
	);
};
